import defaultProfile, { getOrderedConfDefSections } from "./default";
import { commonMenuItems } from "./common";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

function createMenu(): Menu {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
}

function getConfigSections(ctx: ProfileCtx): ConfigSection[] {
  // The slgAccount section renders via the EcoSlgAccount component: a single card
  // with the step-by-step SLG instructions above its username/password fields.
  // Table sections (whitelist/admins/blacklist/mutelist) use TableSection.
  const sections: ConfigSection[] = [];
  for (const [name, section] of getOrderedConfDefSections(ctx)) {
    let component = "ConfSection";
    if (name === "slgAccount") {
      component = "EcoSlgAccount";
    } else if (section.template === "table") {
      component = "TableSection";
    }
    sections.push({ component, props: { name } });
  }
  return sections;
}

export default (ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections: getConfigSections(ctx),
  statusPageConfig: {
    showRconPort: true,
    showQueryPort: false, // ECO has no query port; web + rcon are shown via display_ports
    showFtp: true,
  },
});
